import "./index.scss";

export default function CustomizedOption(props){
    const {children, isSelected, selectOption, data } = props;
    return (
        <div className={`customized-option ${isSelected ? 'selected' : ''}`} onClick={() => {
            selectOption(data);
        }}>
            <div className='customized-option__icon'>
                {isSelected && <i className='icon-Radio-selected' />}
                {!isSelected && <i className='icon-Radio' />}
            </div>
            <div className={`customized-option__content ${isSelected ? "selected" : ""}`}>
                {children}
            </div>
        </div>
    )
}